type CurrencyPeriod = 'day' | 'week' | 'month' | 'year';

export interface CurrencyOptions {
  currency: string;
  locale: string;
  period?: CurrencyPeriod;
}

export const getCurrencySuffix = (currency: string, locale: string): string => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const parts = formatter.formatToParts(0);
  const currencyPart = parts.find((part) => part.type === 'currency');

  return currencyPart?.value || currency;
};

export const formatCurrency = (price: number, { period, ...intl }: CurrencyOptions): string => {
  // Core currency formatting
  const formatted = new Intl.NumberFormat(intl.locale, {
    style: 'currency',
    currency: intl.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(price);

  // If no period requested, we're done
  if (!period) return formatted;

  // Locale-aware mapping table for period suffixes
  const perSuffix: Record<
    string,
    Partial<Record<NonNullable<CurrencyOptions['period']>, string>>
  > = {
    sv: { day: '/dag', week: '/vecka', month: '/mån', year: '/år' },
    nb: { day: '/dag', week: '/uke', month: '/mnd', year: '/år' },
  };

  const lang = intl.locale.split('-')[0]; // "sv" from "sv-SE"
  const suffix = perSuffix[lang]?.[period];

  return suffix ? `${formatted}${suffix}` : formatted; // fallback: no suffix
};
